import type { JSXMapSerializer } from '@prismicio/react';

import { linkAttributes } from './linkAttributes';

import styles from './RichText.module.scss';

/**
 * The rich text hyperlink serializer, shared by `RichText` and other rich
 * text renderers (pull quotes and their attributions) so links resolve and
 * look the same everywhere.
 */
export const richTextHyperlink: NonNullable<JSXMapSerializer['hyperlink']> = ({
  node,
  children,
}) => {
  const link = linkAttributes(node.data);
  // A link with nowhere to go renders its text without a broken `<a>`.
  if (!link) return <>{children}</>;

  return (
    <a className={styles.link} {...link}>
      {children}
    </a>
  );
};
